

import { cn } from 'app/utils/styles.utils';
import { Elegible } from '../utils/utils';

export const Description = ({elegible, className}: {elegible: Elegible, className?: string}) => {
  switch (elegible) {
    case 'elegible':
      return (
        <p className={cn("text-center text-xl tablet:text-base", className)}>
          You&apos;re eligible for season one of the reward program.
        </p>
      );
    case 'claimed':
      return (
        <p className={cn("text-center text-xl tablet:text-base", className)}>
          You have claimed your tokens already.
        </p>
      );
    default:
      return null;
  }
};
